import { HelpCircle, LayoutDashboard, Settings, Shield } from "lucide-react";
import { routes } from "wasp/client/router";

export const userMenuItems = [
  {
    name: "Help Center",
    // Resolved via i18n in the sidebar dropdown; `name` is the English fallback.
    labelKey: "help.navLabel",
    to: routes.HelpRoute.to,
    icon: HelpCircle,
    isAuthRequired: false,
    isAdminOnly: false,
  },
  {
    name: "Account Settings",
    to: routes.AccountRoute.to,
    icon: Settings,
    isAuthRequired: false,
    isAdminOnly: false,
  },
  {
    name: "Admin Dashboard",
    to: routes.AdminRoute.to,
    icon: Shield,
    isAuthRequired: false,
    isAdminOnly: true,
  },
] as const;
